module.exports = __webpack_public_path__ + "assets/china.2496bf57976d92819f61ff200a801247.svg?";